module.exports = __webpack_public_path__ + "img/unionpay.c98a15c3.png";